module.exports = __webpack_public_path__ + "img/gBus.60de659f.png";